/**
 * ReadTimeChip — small pill showing estimated read time in minutes.
 * Reads from GET /api/publisher/v1/articles/{id}/engagement so it
 * matches the server-computed value used everywhere else.
 */
import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api/publisher/v1`;

export default function ReadTimeChip({ articleId, fallbackMinutes }) {
  const [mins, setMins] = useState(fallbackMinutes || null);

  useEffect(() => {
    if (!articleId) return;
    let alive = true;
    fetch(`${BASE}/articles/${articleId}/engagement`)
      .then((r) => r.ok ? r.json() : null)
      .then((d) => { if (alive && d) setMins(d.read_time_minutes); })
      .catch(() => {});
    return () => { alive = false; };
  }, [articleId]);

  if (!mins) return null;
  return (
    <span
      className="inline-flex items-center gap-1 text-xs text-slate-500"
      data-testid="read-time-chip"
    >
      <Clock className="w-3 h-3" />
      {mins} min read
    </span>
  );
}
